import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CareCreditMessageBody } from './care-credit-message-body';
import { CareCreditMessageGenericNavigation } from './navigation/care-credit-message-generic-navigation';

export const CareCreditMessageNavigationSwitch = () => {
  return <StepNavigationSwitch body={CareCreditMessageBody} generic={CareCreditMessageGenericNavigation} />;
};
